import React from 'react'
import classNames from 'classnames'

import Link from '../Link'
import Person from '../Person'

import numeral from 'numeral'

//результаты поиска - в виде карточек или строк
//const LotItem = ({ data, type, onAfterClick }) => <Person onClick={onAfterClick} data={data} isSpecial type={type === 'lot' ? 'lot' : 'member'} linkPrefix={type === 'lot' ? 'lots' : 'members'} />
const FundItem = ({ data, onAfterClick }) => <Link onClick={onAfterClick} to={`/funds/${data._id}`} className='Search__result-item Link Link_light'>{data.name}</Link>
const ExternalPartnerItem = ({ data, type, onAfterClick }) => <Link onClick={onAfterClick} to={`/externalpartners/${data._id}`} className='Search__result-item Link Link_light'>{data.title}</Link>
const ActionItem = ({ data, type, onAfterClick }) => {//<Person onClick={onAfterClick} data={data} isSpecial type='member' linkPrefix='actions' />
return (<Link className='ActionsTable' to={'/actions/' + data._id} key={data._id} onClick={onAfterClick}>
  <div className='ActionsTable__inner'>
    <img className='ActionsTable__img' src={data.image} alt={data.name} />
    <span className='ActionsTable__name SubHead'>{data.title}</span>
    <span className='ActionsTable__price Small'>Собрали: {data.externalPaymentsStats ? 
    ((numeral(data.externalPaymentsStats.sum).format('0,0') == 0) ? 'coming soon' : (numeral(data.externalPaymentsStats.sum).format('0,0') + ' ₽'))
      : "coming soon"}</span>
    <span className='ActionsTable__price2 Small'>Охват: {data.externalPaymentsStats ? 
    ((numeral(data.externalPaymentsStats.personsCount).format('0,0') == 0) ? 'coming soon' : (data.externalPaymentsStats.personsCount + ' людей'))
    : "coming soon"}</span>
    <div className='ActionsTable__gradient' />
  </div>
</Link>)}

const elemTypes = { fund: FundItem, /*lot: LotItem, person: LotItem*/externalpartner: ExternalPartnerItem, action: ActionItem }

const SearchResult = ({ title, items = [], type = '', onAfterClick }) => {
  const Entry = elemTypes[type]
  if (!items.length || !Entry) return null

  return (
    <div className='Search__result-list'>
      <span className='Search__result-head Text'>{title} ({items.length})</span>
      <div className={classNames({ 'Search__result-lot-list': type !== 'fund' })}>
        {items.map(el => <Entry data={el} key={el._id} onAfterClick={onAfterClick} type={type} />)}
      </div>
    </div>
  )
}

export default SearchResult



// WEBPACK FOOTER //
// ./src/components/Search/Result.jsx